import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Checkbox } from 'primeng/checkbox'
import { FreetextSection } from '@features/certificate/models/certificate-shared.model'
import { CertificateBaseComponent } from '@features/certificate/components/certificate-base/certificate-base.component'
import { AlbertInputWrapper } from '@features/certificate/components/certificate-input-wrapper/albert-input-wrapper'
import { AlbertCheckboxComponent } from '@shared/components/albert-checkbox/albert-checkbox.component'
import { AlbertTextareaComponent } from '@shared/components/albert-textarea/albert-textarea.component'

@Component({
  selector: 'albert-freetext-section',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    Checkbox,
    AlbertInputWrapper,
    AlbertCheckboxComponent,
    AlbertTextareaComponent
  ],
  templateUrl: './certificate-freetext-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateFreetextSectionComponent extends CertificateBaseComponent {
  public readonly form = input.required<FormGroup>()
  public readonly section = input.required<FreetextSection>()
  public readonly dataTestPrefix = input.required<string>()
}
